<template>
  <div class="product-template __donate __limited-edu __limited-edu--custom2021 __uob-limitededucation-2025">
    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10 box">
        <h1 data-v-1f20e9ef="" class="text-center mb-20 flex align-items-center justify-content-center">
          <img src="/static/img/uob/uob-limitededucation-2025@2x.png" srcset="/static/img/uob/uob-limitededucation-2025@2x.png" width="240px" alt="TCFE x UOB" class="logo-heartbeat" />
        </h1>
        <h2 class="product-custom-title text-center" v-html="product.meta.product_custom_title"></h2>
        <div class="text-center text-white heading">ร่วมเป็นส่วนหนึ่งในการเปิดประตูสู่โอกาสทางการศึกษาให้กับเยาวชนที่ขาดโอกาส<br />ด้วยการบริจาคพร้อมรับของที่ระลึกพิเศษรุ่น 'Let Me Shine'</div>
      </div>
    </div>


    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
                :show-donate-type="true"
                :product="product"
                v-model="product.price"
                ref="donateChoice"
                classes="col-1-5"
              />

              <div
                v-if="product.price > 0"
                class="sumary-amount mb-15"
              >
                <table class="sumary-amount-detail">
                  <tbody>
                    <tr>
                      <td class="first-row">ใช้ไป</td>
                      <td class="first-row text-right"><strong><span>{{ totalProductPrice }}</span> / {{ product.price }} บาท</strong></td>
                    </tr>
                    <tr>
                      <td>จำนวนของ</td>
                      <td class="text-right"><strong>{{ selectedProductCount }} ชิ้น</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="form__wrapper mt-15 mb-15 _clearboth">

                <!-- NO Option -->
                <div class="form__section">
                  <label class="form__radio-lg">
                    ไม่ต้องการรับของ
                    <input
                      v-model="attributes.info.rewardProduct"
                      class=""
                      type="radio"
                      name="optionsRadios"
                      value=""
                      @click="clearSelectedProducts"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <div
                  v-for="(p, i) in customProducts"
                  :key="i"
                  class="form__section"
                >
                  <label class="form__radio-lg" :class="{disable: !canSelectReward(p)}">
                    รับ{{ p.title }} <span>{{ p.price }} บาท</span><br />
                    <div v-if="p.description" class="product-option-description">{{ p.description }}</div>
                    <div
                      v-if="p.title === attributes.info.rewardProduct && error.rewardConfigSize"
                      class="alert alert--error mt-5"
                      ref="error"
                    >
                      {{ error.rewardConfigSize }}
                    </div>
                    <input
                      v-model="attributes.info.rewardProduct"
                      class=""
                      type="radio"
                      name="optionsRadios"
                      :value="p.title"
                      :disabled="!canSelectReward(p)"
                      @click="onClickSelectReward"
                    />
                    <span class="checkmark"></span>
                  </label>

                  <transition name="slide-down">
                    <div
                      v-show="p.title === attributes.info.rewardProduct"
                      class="product-variation--wrapper slide-down-wrapper"
                      :class="{disable: !canSelectReward(p)}"
                    >
                      <div
                        v-for="variation in p.variations"
                        :key="variation.title"
                        class="product-variation--column"
                        :class="{ 'product-variation--column-full': p.variations.length === 1 }"
                      >
                        <div
                          class="product-variation--item"
                          :class="{
                            selected: selectedProducts[variation.value].quantity > 0
                          }"
                        >
                          <!-- Title -->
                          <div class="mb-10">
                            <strong>{{ variation.title }}</strong>
                          </div>

                          <!-- Thumbnail -->
                          <Thumbnail
                            :images="variation.images"
                          />

                          <!-- Quantity -->
                          <div class="product-quantity--wrapper">
                            <div class="product-quantity--title">เลือกจำนวน</div>
                            <div class="product-quantity--control">
                              <button
                                class="product-quantity--button"
                                @click.prevent="decreaseProductQuantity(variation.value)"
                                :disabled="selectedProducts[variation.value].quantity === 0"
                              >
                                -
                              </button>
                              <span class="product-quantity--quantity">{{ selectedProducts[variation.value].quantity }}</span>
                              <button
                                class="product-quantity--button"
                                @click.prevent="increaseProductQuantity(variation.value)"
                                :disabled="totalProductPrice + p.price > product.price"
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div><!-- end form wrapper -->

              <!-- ข้อมูลเพิ่มเติม -->
              <div> 
                 <!-- ตำแหน่ง และ หน่วยงาน -->
                <div class="row mt-15" v-if="attributes.info.rewardProduct">
                  <div class="col-sm-12 col-md-6">
                    <!-- ตำแหน่ง -->
                    <div class="pt-15">
                      <div><strong>ระบุตำแหน่ง <span style="color: #E82B27">*</span></strong></div>
                      <div class="form__select">
                        <!-- rewardConfigChoice (ตำแหน่ง) -->
                        <select v-model="attributes.info.rewardConfigChoice">
                          <option value="">-- โปรดระบุตำแหน่ง --</option>
                          <option
                            v-for="LevelOption in LevelOptions"
                            :key="LevelOption.text"
                            :value="LevelOption.description"
                          >
                            {{ LevelOption.description }}
                          </option>
                        </select>
                      </div>
                      <div class="alert alert--error" v-if="error.rewardConfigChoice">กรุณาระบุตำแหน่ง</div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <!-- หน่วยงาน -->
                    <div class="pt-15">
                      <div><strong>ระบุหน่วยงานของท่าน <span style="color: #E82B27">*</span></strong></div>
                      <div class="form__select">
                        <!-- rewardConfigText (หน่วยงาน) -->
                        <select v-model="attributes.info.rewardConfigText">
                          <option value="">-- โปรดระบุหน่วยงาน --</option>
                          <option
                            v-for="FunctionOption in FunctionOptions"
                            :key="FunctionOption.text"
                            :value="FunctionOption.description"
                          >
                            {{ FunctionOption.description }}
                          </option>
                        </select>
                      </div>
                      <div class="alert alert--error" v-if="error.rewardConfigText">กรุณาระบุหน่วยงานของท่าน</div>
                    </div>
                  </div>
                </div>
                <!-- สถานที่รับของที่ระลึก -->
                <div class="container-fluid pa-0 pt-15 mt-15" v-if="attributes.info.rewardProduct">
                  <div class="row">
                    <div class="col-sm-6 col-md-6">
                      <div><strong>ระบุสถานที่รับของ <span style="color: #E82B27">*</span></strong><br />
                        <span class="text-remark">พนักงานสาขาจัดส่งให้ที่สาขา โปรดระบุสาขาที่รับของท่านให้ถูกต้อง</span>
                      </div>
                      <div class="form__select">
                        <select v-model="attributes.info.pickupPoint">
                          <option value="">-- โปรดระบุสถานที่ --</option>
                          <option
                            v-for="PlaceOption in PlaceOptions"
                            :key="PlaceOption.name"
                            :value="PlaceOption.name"
                          >
                            {{ PlaceOption.name }}
                          </option>
                        </select>
                      </div>
                      <div class="alert alert--error" v-if="error.pickupPoint">กรุณาระบุสาขาที่รับของที่ระลึก</div>

                      <div v-if="isPlaceOptionType('select')">
                        <div v-if="selectedPlaceOption.params.optionTitle"><strong>{{ selectedPlaceOption.params.optionTitle }} <span style="color: #E82B27">*</span></strong></div>
                        <div class="form__select">
                          <select v-model="attributes.info.pickupDetail">
                            <option selected value="">-- {{ selectedPlaceOption.params.optionLabel }} --</option>
                            <option
                              v-for="item in selectedPlaceOption.params.optionType.items"
                              :key="item.name"
                              :value="item.name"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                        </div>
                        <div class="alert alert--error" v-if="error.pickupDetail">
                          <span v-if="selectedPlaceOption.params.required">{{ selectedPlaceOption.params.required }}</span>
                          <span v-else>กรุณากรอกข้อมูล</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <div class="">
                        <div v-if="isPlaceOptionType('text')" class="">
                          <label v-if="selectedPlaceOption.params.optionLabel" for="info_name2_text" class="form__label">
                            <strong>
                              {{ selectedPlaceOption.params.optionLabel }} <span style="color: #E82B27">*</span>
                            </strong><br />
                            <span class="text-remark">{{selectedPlaceOption.params.optionNote}}</span>
                          </label>
                          <input id="info_name2_text" class="form__text" type="text" v-model="attributes.info.pickupDetail" />
                          <div class="alert alert--error" v-if="error.pickupDetail">
                            <span v-if="selectedPlaceOption.params.required">{{ selectedPlaceOption.params.required }}</span>
                            <span v-else>กรุณากรอกข้อมูล</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />

              <div class="text-center">
                <div class="alert alert--warning">โปรดตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่มสั่งของที่ระลึก</div>
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">กดเพื่อบริจาค/ชำระเงิน</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  import Thumbnail from '@/components/Thumbnail'
  import Parser from '@/parser'

  export default {
    name: 'ProductTemplateUobLimitedEducation2025',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice,
      Thumbnail
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {
          info: {
            name: '',
            rewardProduct: '',
            rewardConfigChoice: '',
            rewardConfigText: '',
            pickupPoint: '',
            pickupDetail: '',
            rewardConfigSize: '',
            shippingRequired: false
          },
          page: ''
        },
        error: {
          rewardConfigSize: false,
          rewardConfigChoice: false,
          rewardConfigText: false,
          pickupPoint: false,
          pickupDetail: false
        },
        selectedSize: {},
        selectedProducts: {},
        currentThumbnailImage: ''
      }
    },

    computed: {
      customProducts () {
        return JSON.parse(this.product.meta.product_custom_products)
      },

      totalProductPrice () {
        return Object.values(this.selectedProducts).reduce((sum, product) => {
          return sum + (product.price * product.quantity)
        }, 0)
      },

      remainingBalance () {
        return this.isRewardDisabled ? 0 : this.product.price - (this.totalRewardItems * this.itemPrices[this.currentRewardIndex])
      },

      selectedProductCount () {
        return Object.values(this.selectedProducts).reduce((sum, product) => {
          return sum + product.quantity
        }, 0)
      },
      // ตำแหน่ง
      LevelOptions () {
        if (!this.product.meta.donation_level_option) return []
        // 1:Managing Director,2:Executive Director
        return this.product.meta.donation_level_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // หน่วยงาน
      FunctionOptions () {
        if (!this.product.meta.donation_function_option) return []
        // 1:Personal Financial Services, 2:Project Management Office
        return this.product.meta.donation_function_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // สถานที่
      PlaceOptions () {
        if (!this.product.meta.donation_place_option) return []
        return Parser.uob.parsePlaceOption(this.product.meta.donation_place_option)
      },
      selectedPlaceOption () {
        return this.PlaceOptions.find((opt) => opt.name === this.attributes.info.pickupPoint)
      }
    },

    created () {
      this.initSelectedProducts()
    },

    methods: {
      hasPlaceOptionDetail () {
        return this.selectedPlaceOption && this.selectedPlaceOption.params && this.selectedPlaceOption.params.optionType
      },
      isPlaceOptionType (type) {
        return this.hasPlaceOptionDetail() && this.selectedPlaceOption.params.optionType.type === type
      },
      initSelectedProducts () {
        const selectedProducts = {}
        for (const product of this.customProducts) {
          if (product.variations) {
            for (const variation of product.variations) {
              selectedProducts[variation.value] = {
                price: variation.price || product.price,
                quantity: 0
              }
            }
          }
        }
        this.selectedProducts = selectedProducts
      },

      validate () {
        this.error.rewardConfigSize = false
        this.error.rewardConfigChoice = false
        this.error.rewardConfigText = false
        this.error.pickupPoint = false
        this.error.pickupDetail = false

        let valid = true
        const {info} = this.attributes

        // Validate selection.
        if (info.rewardProduct) {
          if (this.selectedProductCount === 0) {
            this.error.rewardConfigSize = 'กรุณาเลือกของ'
            valid = false
          } else if (this.totalProductPrice > this.product.price) {
            this.error.rewardConfigSize = 'เลือกของเกินจำนวนบริจาค'
            valid = false
          } else if (!info.rewardConfigChoice) {
            this.error.rewardConfigChoice = true
            valid = false
          } else if (!info.rewardConfigText) {
            this.error.rewardConfigText = true
            valid = false
          } else if (!info.pickupPoint) {
            this.error.pickupPoint = true
            valid = false
          } else if (this.selectedPlaceOption && this.hasPlaceOptionDetail() && !info.pickupDetail) {
            this.error.pickupDetail = true
            valid = false
          }
        }

        if (!valid) {
          setTimeout(() => {
            this.scrollToElement(this.$refs.error[0])
          }, 300)
        }

        return valid
      },

      scrollToElement (el) {
        const rect = el.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const top = rect.top + scrollTop

        window.scrollTo({ left: 0, top: top - 60, behavior: 'smooth' })
      },

      async donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        if (!this.validate()) {
          return
        }

        // Update reward info.
        if (this.attributes.info.rewardProduct) {
          // Copy info to update size before re-assign back.
          const info = JSON.parse(JSON.stringify(this.attributes.info))

          // Update selected products.
          Object.keys(this.selectedProducts).forEach(key => {
            const product = this.selectedProducts[key]
            if (product.quantity > 0) {
              info[key] = product.quantity
            }
          })
          // Re-assign info back to attributes.
          this.attributes.info = info
        }
        if (this.product.meta.receipt_item_description) {
          this.attributes.info._receiptItemDescription = this.product.meta.receipt_item_description
        }
        if (this.product.meta.receipt_item_code) {
          this.attributes.info._receiptItemCode = this.product.meta.receipt_item_code
        }
        // Clear previous cart info.
        await this.$store.dispatch('clearCart')
        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      },
      canSelectReward (product) {
        return this.product.price >= product.price
      },
      onClickSelectReward (e) {
        this.attributes.info.rewardProduct = e.currentTarget.value
        this.clearSelectedProducts()
      },
      increaseProductQuantity (product) {
        this.selectedProducts[product].quantity += 1
        this.error.rewardConfigSize = ''
      },
      decreaseProductQuantity (product) {
        this.selectedProducts[product].quantity -= 1
        this.error.rewardConfigSize = ''
      },
      clearSelectedProducts () {
        this.error.rewardConfigSize = ''
        Object.keys(this.selectedProducts).forEach(key => {
          this.selectedProducts[key].quantity = 0
        })
      }
    },

    watch: {
      'product.price': function (amount) {
        this.clearSelectedProducts()
        // Reward product is selected.
        if (amount && this.attributes.info.rewardProduct) {
          // Check donate amount cover selected reward product or not.
          const product = this.customProducts.find(product => product.title === this.attributes.info.rewardProduct)
          if (amount < product.price) {
            this.attributes.info.rewardProduct = ''
          }
        } else if (!amount) {
          this.attributes.info.rewardProduct = ''
        } else {
          this.attributes.info.rewardProduct = this.customProducts[0].title
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .logo-heartbeat {
    width: 100px;
  }
  .logo {
    width: 150px;
  }
}

.product-custom-title {
  color: #005eb6;
}

.product-option-description {
  margin-top: 4px;
  font-weight: 300;
  color: gray;
}

.product-quantity {
  &--wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #ccc;
  }
  &--title {
    font-size: 1.25rem;
    font-weight: 500;
  }

  &--control {
    display: flex;
  }

  &--quantity {
    line-height: 40px;
    width: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 1.5rem;
  }

  &--button {
    font-size: 2rem;
    border-radius: 8px;
    border: none;
    background-color: #D8D8D8;
    color: #808080;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    text-decoration: none;
    cursor: pointer;
    line-height: 1;

    &:hover {
      background-color: #CCC;
    }
  }
}

.product-variation {
  &--wrapper {
    display: flex;
    padding: 16px;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    flex-wrap: wrap;
  }


  &--column {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 50%;
    max-width: 50%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-block: 0.5rem;

    // &-full {
    //   flex-basis: 100%;
    //   max-width: 100%;
    // }
  }

  &--item {
    background-color: #fff;
    padding: 16px;
    border: 4px solid transparent;
    font-size: 90%;
    line-height: 1.5;

    &.selected {
      border-color: #5ABE0A;
    }
  }
}

  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

  .slide-down-wrapper {
    margin-top: 15px;
    margin-bottom: -15px;
    background-color: #EEEFEB;
  }

  .current-thumbnail-wrapper {
    cursor: zoom-in;
  }

  .thumbnail-wrapper {
    border: 1px solid transparent;
    cursor: pointer;

    &.selected {
      border-color: #F8941D;
    }
  }

  .size-choice {
    cursor: pointer;

    &.only-one {
      .number-field {
        display: none;
      }
    }

    &.active {
      border: 1px solid #F8941D;
    }
  }
  .btn--default {
    background: #E32828;
    border-color: #E32828;
  }
</style>



// WEBPACK FOOTER //
// uob-limitededucation-2025.vue?26d83d3d